import VueRouter from 'vue-router'
import di from 'di'

import AppTemplate from 'app/components/Template.vue'
import CmsError from '@wittignl/js-cms/components/views/Error.vue'

import Loggers from 'app/components/routes/logger/Loggers.vue'
import LoggerForm from 'app/components/routes/logger/LoggerForm.vue'
import ViewLogger from 'app/components/routes/logger/ViewLogger.vue'

import SelectLoggers from 'app/components/routes/logger/SelectLoggers.vue'

import Repairs from 'app/components/routes/repair/Repairs.vue'
import ViewRepair from 'app/components/routes/repair/ViewRepair.vue'
import RepairForm from 'app/components/routes/repair/RepairForm.vue'

import Actions from 'app/components/routes/action/Actions.vue'
import ActionForm from 'app/components/routes/action/ActionForm.vue'
import ViewAction from 'app/components/routes/action/ViewAction.vue'

import Projects from 'app/components/routes/project/Projects.vue'
import ProjectForm from 'app/components/routes/project/ProjectForm.vue'

import LoggerTypes from 'app/components/routes/logger-type/LoggerTypes.vue'
import LoggerTypeForm from 'app/components/routes/logger-type/LoggerTypeForm.vue'

import UserRole from 'app/enums/UserRole'

export default class {

    run(){

        const routes = [
            {
                path: '/',
                component: AppTemplate,
                redirect: { name: 'loggers' },
                children: [

                    // LOGGERS
                    {
                        name: 'loggers',
                        path: 'loggers',
                        component: Loggers
                    },
                    {
                        name: 'loggers-project',
                        path: 'loggers/project/:projectCode',
                        component: Loggers
                    },
                    {
                        name: 'logger-add',
                        path: 'loggers/add',
                        component: LoggerForm
                    },
                    {
                        name: 'logger-edit',
                        path: 'loggers/edit/:id',
                        component: LoggerForm
                    },
                    {
                        name: 'logger-view',
                        path: 'loggers/view/:id',
                        component: ViewLogger
                    },

                    // SELECT LOGGERS
                    {
                        name: 'select-loggers',
                        path: 'select-loggers',
                        component: SelectLoggers
                    },

                    // REPAIRS
                    {
                        name: 'repairs',
                        path: 'repairs',
                        component: Repairs
                    },
                    {
                        name: 'repair-view',
                        path: 'repairs/:id',
                        component: ViewRepair
                    },
                    {
                        name: 'repair-edit',
                        path: 'repairs/edit/:id',
                        component: RepairForm
                    },

                    // ACTIONS
                    {
                        name: 'actions',
                        path: 'actions',
                        component: Actions
                    },
                    {
                        name: 'action-add',
                        path: 'actions/add/:loggerId',
                        component: ActionForm
                    },
                    {
                        name: 'action-edit',
                        path: 'actions/edit/:id/:mode?',
                        component: ActionForm
                    },
                    {
                        name: 'action-view',
                        path: 'actions/view/:id',
                        component: ViewAction
                    },

                    // PROJECTS
                    {
                        name: 'projects',
                        path: 'projects',
                        component: Projects
                    },
                    {
                        name: 'project-add',
                        path: 'projects/add',
                        component: ProjectForm
                    },
                    {
                        name: 'project-edit',
                        path: 'projects/edit/:id',
                        component: ProjectForm
                    },

                    // LOGGER TYPES
                    {
                        name: 'logger-types',
                        path: 'logger-types',
                        component: LoggerTypes
                    },
                    {
                        name: 'logger-type-add',
                        path: 'logger-types/add',
                        component: LoggerTypeForm
                    },
                    {
                        name: 'logger-type-edit',
                        path: 'logger-types/edit/:id',
                        component: LoggerTypeForm
                    }
                ]
            },
            {
                path: '*',
                component: CmsError,
                meta: {
                    authorized: false
                }
            }
        ];

        const router = new VueRouter({
            mode: 'history',
            linkActiveClass: 'active',
            routes
        });

        const restrictedRoutes = ['logger-types', 'logger-type-add', 'logger-type-edit', 'projects', 'project-add', 'project-edit', 'repairs', 'repair-view', 'repair-edit'];
        const adminRoutes = ['logger-edit', 'logger-type-add', 'logger-type-edit', 'project-add', 'project-edit', 'repair-edit'];

        router.beforeEach((to, from, next) => {

            if(to.meta.authorized === false){
                next();
                return;
            }

            let auth = di.get('auth');
            const config = di.get('config');

            if(!auth.loggedIn()) {
                document.location.href = config.loginUrl;
            }
            else {

                const user = auth.getSession().getIdentity();

                if((restrictedRoutes.indexOf(to.name) !== -1 && user.role !== UserRole.ADMIN && user.role !== UserRole.ADVISOR) || (adminRoutes.indexOf(to.name) !== -1 && user.role !== UserRole.ADMIN)){

                    di.get('toast').warning("Je hebt geen toegang tot deze pagina");
                    next(false);
                }
                else {
                    next();
                }
            }
        });

        di.set('router', router);
    }
}
